// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__3VYpy","calendarButtons":"ClockData_calendarButtons__2uuJq"};